<template>
  <div
    :id="id"
    class="properties-field"
  >
    <div class="wrap-properties">
      <!-- Configuration Title -->
      <div class="properties-field-title">
        <h4 class="title">Configuration</h4>
        <div
          class="close-properties"
          @click="!showModalFieldLibrary ? closeConfiguration() : null"
        >
          &times;
        </div>
      </div>

      <!-- Configuration Content -->
      <div class="properties-field-content properties-field-content-config">
        <!-- Title -->
        <div class="section-field input-field">
          <h4 class="title-section">General</h4>

          <b-form
            :class="{'error-input' : $v.dataSetup.title.$error}"
            class="input-field m__b--14">
            <label> Title </label>
            <j-input
              v-model="dataSetup.title"
              :error-required="false"
              placeholder="Enter title view"
            />
          </b-form>
        </div>

        <!-- Event list section -->
        <div class="section-field input-field">
          <h4 class="title-section">Event List</h4>

          <div class="configuration-section">
            <h4 class="configuration-section-title">Parse value to column</h4>
            <p class="configuration-section-desc">
              Select column to mapping parse data
            </p>

            <b-form :class="{'error-input' : $v.dataSetup.column.title.$error}">
              <label> Title </label>
              <j-single-select
                v-model="dataSetup.column.title"
                :options="variables.text"
                :placeholder="'Select Column'"
                label="label"/>
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.column.description.$error}">
              <label> Description </label>
              <j-single-select
                v-model="dataSetup.column.description"
                :options="variables.text"
                :placeholder="'Select Column'"
                label="label"/>
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.column.start_date_time.$error}">
              <label> Start Date Time </label>
              <j-single-select
                v-model="dataSetup.column.start_date_time"
                :options="variables.date"
                :placeholder="'Select Column'"
                label="label"/>
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.column.end_date_time.$error}">
              <label> End Date Time </label>
              <j-single-select
                v-model="dataSetup.column.end_date_time"
                :options="variables.date"
                :placeholder="'Select Column'"
                label="label"/>
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.column.color.$error}">
              <label> Color </label>
              <j-single-select
                v-model="dataSetup.column.color"
                :options="variables.text"
                :placeholder="'Select Column'"
                label="label"/>
            </b-form>
          </div>
        </div>

        <!-- Data source section -->
        <div class="section-field input-field">
          <h4 class="title-section">Data Source</h4>

          <!-- Filter Configuration -->
          <div class="configuration-section">
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Filter</h4>
                <p class="configuration-section-desc">
                  Filter data according to the parameters
                </p>
              </div>

              <!-- Filter Operator -->
              <div class="filter-option">
                <div class="filter-selected">{{ dataSetup.filterOperator }}</div>
                <i
                  class="fa fa-chevron-down"
                  @click="showFilterOptions = true"
                />

                <!-- Select Filter Operator -->
                <div
                  v-if="showFilterOptions"
                  class="filter-options"
                >
                  <p>Operator</p>

                  <div class="d-flex align-items-center justify-content-around">
                    <div
                      v-for="operator in filterOperatorOptions"
                      :key="operator.id"
                      :class="{'operator-selected': operator.id === dataSetup.filterOperator }"
                      class="operator-option"
                      @click="closeFilterOptions(operator.id)"
                    >
                      {{ operator.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filter by Value -->
            <h3 class="configuration-section-subtitle">By Value</h3>
            <div
              v-for="(data, index) in dataSetup.filter"
              :key="index"
              class="div-filter"
            >
              <div class="header-filter">
                <div class="index">{{ index + 1 }}</div>
                <i
                  class="fa fa-trash"
                  @click="deleteFilter(index)"
                />
              </div>
              <b-form class="mb-2">
                <label> Column </label>
                <j-single-select
                  v-model="data.key"
                  :error-required="false"
                  :options="variables.options"
                  :placeholder="'Select Column'"
                  value-format="object"
                  label="label"/>
              </b-form>
              <b-form>
                <label> Value </label>
                <j-input
                  v-model="data.value"
                  :error-required="false"
                  :placeholder="'Input Filter Value'"/>
              </b-form>
            </div>

            <div
              class="btn-add-config"
              @click="addFilter">
              + Add Parameter
            </div>

            <div class="separator" />

            <!-- Filter by Function -->
            <h3 class="configuration-section-subtitle">By Function</h3>
            <div
              v-for="(data, index) in dataSetup.filter_function"
              :key="index"
              class="div-filter"
            >
              <div class="header-filter">
                <div class="index">{{ index + 1 }}</div>
                <i
                  class="fa fa-trash"
                  @click="deleteFilterFunction(index)"
                />
              </div>
              <b-form class="mb-2">
                <label> Column </label>
                <j-single-select
                  v-model="data.key"
                  :error-required="false"
                  :options="variables.options"
                  :placeholder="'Select Column'"
                  value-format="object"
                  label="label"/>
              </b-form>
              <b-form>
                <label> Function </label>
                <j-single-select
                  v-model="data.value"
                  :options="listFunction"
                  :placeholder="'Select Function'"
                  :error-required="false"
                  label="name" />
              </b-form>
            </div>

            <div
              class="btn-add-config"
              @click="addFilterFunction">
              + Add Parameter
            </div>
          </div>

          <!-- Server Side Pagination Configuration -->
          <!-- <div class="configuration-section">
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Server Side Pagination</h4>
                <p class="configuration-section-desc">
                  Server-side pagination requests each page individually loaded upon navigation
                </p>
              </div>
              <j-toggle
                v-model="dataSetup.server_side_pagination"
                class="toggle" />
            </div>
          </div> -->
        </div>

        <!-- Sorting Properties -->
        <div class="section-field input-field">
          <div class="configuration-section">
            <h4 class="configuration-section-title">Sorting</h4>
            <p class="configuration-section-desc">
              The displayed data can be sorted according to the specified parameters
            </p>
            <b-form
              :class="{'error-input' : $v.dataSetup.sorting.key.$error}"
              class="mb-2"
            >
              <label> Column </label>
              <j-single-select
                v-model="dataSetup.sorting.key"
                :error-required="false"
                :options="variables.options"
                :placeholder="'Select column'"
                value-format="object"
                label="label"/>
            </b-form>

            <b-form
              :class="{'error-input' : $v.dataSetup.sorting.order.$error}"
              class="mb-3"
            >
              <label> Order Type </label>
              <j-single-select
                v-model="dataSetup.sorting.order"
                :error-required="false"
                :options="orderOptions"
                :placeholder="'Select order type'"
                value-format="object"
                label="label"/>
            </b-form>
          </div>
        </div>

        <!-- Search Options Section -->
        <div class="section-field input-field">
          <h4 class="title-section">Search Options</h4>

          <!-- Fields Search Options Configuration -->
          <div class="configuration-section">
            <h4 class="configuration-section-title">Fields</h4>
            <p class="configuration-section-desc">
              The field used can be adjusted as needed
            </p>

            <draggable
              v-model="dataSetup.search_options_list"
              :options="{
                animation:300,
                handle:'.icon-drag'
              }"
              class="d-flex flex-wrap"
            >
              <div
                v-for="(data, index) in dataSetup.search_options_list"
                :key="index"
                :class="{'selected': index === selectedIndexField}"
                class="field-list"
              >
                <p class="column-name">{{ data.name }}</p>

                <field-preview
                  :column="data"
                />

                <!-- Edit or Delete -->
                <div class="edit-or-delete">
                  <div class="button">
                    <!-- Edit -->
                    <div
                      class="edit"
                      @click="editField(index)"
                    >
                      <i class="fa fa-pencil-square-o" />
                    </div>
                    <!-- Delete -->
                    <div
                      class="delete"
                      @click="deleteField(index)"
                    >
                      <i class="fa fa-trash" />
                    </div>
                  </div>
                </div>
              </div>
            </draggable>

            <div
              class="btn-add-config"
              @click="openModalFieldLibrary"
            >
              + Add Field
            </div>
          </div>
        </div>
      </div>

      <!-- Configuration Button -->
      <div class="properties-field-button justify-content-end">
        <div class="d-flex align-items-center">
          <button
            :disabled="showModalFieldLibrary"
            class="button-border mr-2"
            @click="closeConfiguration"
          >
            Close
          </button>

          <button
            :disabled="showModalFieldLibrary"
            class="button-blue"
            @click="submitForm"
          >
            Apply
          </button>
        </div>
      </div>
    </div>

    <!-- Properties -->
    <properties-field
      v-if="selectedField"
      :ref="idProperties"
      :id="[idProperties]"
      :field-detail="selectedField"
      :variable-options="variables.options"
      :field-ui-key="dataSetup.search_options_list"
      :is-detail-view="true"
      :is-group="true"
      :is-new-field="isNewFieldGroup"
      @delete-field="deleteField"
      @close-properties="togglePropertiesField(false)"
      @submit-mode="submitField"
    />
  </div>
</template>

<script>
/* eslint-disable max-len */
import { required } from 'vuelidate/lib/validators';
import draggable from 'vuedraggable';
import PropertiesField from '@/views/experience-manager-v2/partials/PropertiesField';
import FieldPreview from '@/views/experience-manager-v2/partials/FieldPreview';
// Mixins
import jMixAutoScroll from '@/mixins/jMixAutoScroll';
import jMixConfiguration from '@/mixins/form-ui-v2/jMixConfiguration';

export default {
  name: 'CalendarConfiguration',

  components: {
    draggable,
    PropertiesField,
    FieldPreview,
  },

  mixins: [jMixAutoScroll, jMixConfiguration],

  props: {
    id: {
      type: String,
      default: '',
    },
    dataConfig: {
      type: Object,
      default: () => {},
    },
    listFunction: {
      type: Array,
      default: () => [],
    },
    variables: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      dataSetup: {
        title: null,
        column: {
          title: null,
          description: null,
          color: null,
          start_date_time: null,
          end_date_time: null,
        },
        sorting: {
          key: null,
          order: null,
        },
        filter: [
          {
            key: null,
            value: null,
          },
        ],
        filter_function: [
          {
            key: null,
            value: null,
          },
        ],
        filterOperator: null,
        search_options_list: [],
      },
    };
  },

  created() {
    if (this.dataConfig) {
      this.dataSetup.title = this.dataConfig.title;
      this.dataSetup.filter = this.dataConfig.filter;
      this.dataSetup.filter_function = this.dataConfig.filter_function;
      this.dataSetup.filterOperator = this.dataConfig.filter_operator || 'and';
      this.dataSetup.search_options_list = this.dataConfig.search_options_list || [];
      this.dataSetup.column = {
        title: this.dataConfig.column.title || null,
        description: this.dataConfig.column.description || null,
        color: this.dataConfig.column.color || null,
        start_date_time: this.dataConfig.column.start_date_time || null,
        end_date_time: this.dataConfig.column.end_date_time || null,
      };
      this.dataSetup.sorting = this.dataConfig.sorting;
    }
  },
  methods: {
    // Open/close stacked properties
    togglePropertiesField(status) {
      if (status) {
        setTimeout(() => {
          const element = document.getElementById(this.idProperties);
          const elementParent = document.getElementById(this.id);
          if (element) {
            elementParent.classList.add('show-properties-group');
            element.classList.add('show-properties-field');
          }
        }, 200);
      } else {
        const element = document.getElementById(this.idProperties);
        const elementParent = document.getElementById(this.id);
        if (element) {
          element.classList.remove('show-properties-field');
          elementParent.classList.remove('show-properties-group');
        }

        setTimeout(() => {
          this.selectedField = null;
          this.selectedIndexField = null;
          this.isNewFieldGroup = false;
          this.setIsSearch(false);
        }, 200);
      }
    },

    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$emit('submit', this.dataSetup);
        this.closeConfiguration();
      } else {
        this.scrollToErrorField('error-input');
      }
    },

    closeConfiguration() {
      this.$emit('close-configuration');

      setTimeout(() => {
        this.dataSetup = {
          title: null,
          column: {
            title: null,
            description: null,
            color: null,
            start_date_time: null,
            end_date_time: null,
          },
          sorting: {
            key: null,
            order: null,
          },
          filter: [
            {
              key: null,
              value: null,
            },
          ],
          filter_function: [
            {
              key: null,
              value: null,
            },
          ],
          filterOperator: null,
          search_options_list: [],
        };

        this.$v.dataSetup.$reset();
      }, 400);
    },
  },

  validations() {
    return {
      dataSetup: {
        title: { required },
        column: {
          title: { required },
          description: { required },
          color: { required },
          start_date_time: { required },
          end_date_time: { required },
        },
        filter: {},
        filter_function: {},
        filterOperator: {},
        sorting: {
          key: { required },
          order: { required },
        },
        search_options_list: {},
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/configuration/CalendarConfiguration.vue